

import m1 from "assets/images/users/1.jpg";
import m2 from "assets/images/users/2.jpg";
import m3 from "assets/images/users/3.jpg";
import m4 from "assets/images/users/4.jpg";
import m5 from "assets/images/users/5.jpg";
import m6 from "assets/images/users/6.jpg";
import m7 from "assets/images/users/7.jpg";
import m8 from "assets/images/users/8.jpg";
import m9 from "assets/images/users/9.jpg";
import fm1 from "assets/images/users/01.jpg";
import fm2 from "assets/images/users/02.jpg";
import fm3 from "assets/images/users/03.jpg";
import fm5 from "assets/images/users/05.jpg";
import fm6 from "assets/images/users/06.jpg";
import fm7 from "assets/images/users/07.jpg";
import fm8 from "assets/images/users/08.jpg";
import fm9 from "assets/images/users/09.jpg";

export const TaskCompletionData = [
    {
        user: {
            fullName: "Macauley Haworth",
            designation: "design intern",
            image: m1
        },
        data: [
            {
                volume: 1,
                value: 4.2,
                date: '1/1/2023'
            },
            {
                volume: 1,
                value: 6.2,
                date: '15/1/2023'
            },
            {
                volume: 1.5,
                value: 7.2,
                date: '22/2/2023'
            },
            {
                volume: 1.75,
                value: 7.2,
                date: '20/2/2023'
            },
            {
                volume: 1,
                value: 8.6,
                date: '15/4/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/11/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/12/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Tahmid Boyd",
            designation: "design intern",
            image: m2
        },
        data: [
            {
                volume: 1.5,
                value: 4.2,
                date: '10/2/2023'
            },
            {
                volume: 1,
                value: 6.2,
                date: '22/2/2023'
            },
            {
                volume: 1.5,
                value: 7.2,
                date: '28/2/2023'
            },
            {
                volume: 1.75,
                value: 7.2,
                date: '12/5/2023'
            },
            {
                volume: 1,
                value: 8.6,
                date: '15/5/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/5/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '18/6/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/7/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/7/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Emily Knights",
            designation: "design intern",
            image: fm2
        },
        data: [

            {
                volume: 1.75,
                value: 7.2,
                date: '20/3/2023'
            },
            {
                volume: 1,
                value: 8.6,
                date: '15/3/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/5/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '18/5/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/8/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/8/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Alisa Contreras",
            designation: "design intern",
            image: fm3
        },
        data: [

            {
                volume: 1.75,
                value: 7.2,
                date: '20/3/2023'
            },
            {
                volume: 1.25,
                value: 8.6,
                date: '15/10/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/11/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '28/4/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/6/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/6/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Hattie Miranda",
            designation: "design intern",
            image: fm5
        },
        data: [

            {
                volume: 1.75,
                value: 7.2,
                date: '2/1/2023'
            },
            {
                volume: 1.25,
                value: 8.6,
                date: '15/1/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/1/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '28/3/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/4/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/6/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Virginia Hewitt",
            designation: "Front End Engineer",
            image: m4
        },
        data: [

            {
                volume: 1.75,
                value: 7.2,
                date: '12/4/2023'
            },
            {
                volume: 1.25,
                value: 8.6,
                date: '15/9/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/8/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '28/7/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/6/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/4/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Macauley Haworth",
            designation: "Front End Engineer",
            image: m6
        },
        data: [

            {
                volume: 1.75,
                value: 7.2,
                date: '12/3/2023'
            },
            {
                volume: 1.25,
                value: 8.6,
                date: '25/3/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/3/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '28/4/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/11/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/12/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Tahmid Boyd",
            designation: "Back End Engineer",
            image: m7
        },
        data: [

            {
                volume: 1.75,
                value: 7.2,
                date: '12/6/2023'
            },
            {
                volume: 1.25,
                value: 8.6,
                date: '25/10/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/12/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '28/11/2023'
            },
            {
                volume: 1.75,
                value: 12.45,
                date: '14/10/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '20/11/2023'
            },
        ]
    },
    {
        user: {
            fullName: "Macauley Haworth",
            designation: "Back End Engineer",
            image: m9
        },
        data: [

            {
                volume: 1.5,
                value: 7.2,
                date: '12/8/2023'
            },
            {
                volume: 1.25,
                value: 8.6,
                date: '25/6/2023'
            },
            {
                volume: 1,
                value: 9.6,
                date: '22/4/2023'
            },
            {
                volume: 1,
                value: 10.67,
                date: '28/9/2023'
            },
            {
                volume: 1.15,
                value: 12.45,
                date: '14/10/2023'
            },
            {
                volume: 1,
                value: 14.5,
                date: '10/9/2023'
            },
        ]
    },

]